import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import './acceso_viewer.css';
import ForgotPasswordViewer from './ForgotPasswordViewer';

const AccesoViewer = () => {
  const [formData, setFormData] = useState({
    usuario: '',
    clave: ''
  });
  const [error, setError] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const [showForgot, setShowForgot] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleInicioSesion = async (e) => {
    e.preventDefault();
    
    // Validación básica
  if (!formData.usuario || !formData.clave) {
      setError('Por favor completa todos los campos');
      return;
    }

    if (!captchaToken) {
      setError('Por favor confirma que no eres un robot.');
      return;
    }

    try {
  const formDataToSend = new FormData();
      formDataToSend.append('Nombre_usu_vie', formData.usuario);
      formDataToSend.append('email', formData.usuario);
      formDataToSend.append('password', formData.clave);
      formDataToSend.append('captcha_token', captchaToken);

      const response = await fetch(`${process.env.REACT_APP_AUTH_VIEWER_URL}/ingreso.php`, {
        method: 'POST',
        body: formDataToSend
      });

      const data = await response.json();

      if (data.status === 'success' && data.data.success) {
        // Guardar token e información de sesión
        localStorage.setItem('userToken', data.data.token);
        localStorage.setItem('userId', data.data.user.id);
        localStorage.setItem('userName', data.data.user.Nombre_usu_vie);
        localStorage.setItem('userEmail', data.data.user.email);
  
        // Obtener el perfilId de donde venía (si existe)
        const returnToProfile = localStorage.getItem('returnToProfile');
  
        // Mostrar overlay de éxito
        showSuccessOverlay();
  
        // Redirigir después de 3 segundos
        setTimeout(() => {
          if (returnToProfile) {
            // Usar window.location.href para asegurar que se recargue correctamente con parámetros
            window.location.href = `/perfil?id=${returnToProfile}`;
          } else {
            navigate('/');
          }
        }, 3000);
} else {
        setError(data.message || 'Usuario o contrasena incorrectos');
      }
  } catch (error) {
      console.error('Error al iniciar sesión:', error);
      setError('Error de conexión. Por favor intenta nuevamente.');
    } finally {
      setCaptchaToken(null);
      if (captchaRef.current) captchaRef.current.reset();
    }
  };

  const handleRegistrarse = () => {
    // Redirigir a la página de registro
    navigate('/registro_viewer');
  };

  const showSuccessOverlay = () => {
  const overlay = document.createElement('div');
  overlay.className = 'login-overlay success';
  overlay.innerHTML = `
    <div class="overlay-content">
      <i class="fas fa-check-circle"></i>
      <h2>INGRESO EXITOSO</h2>
    </div>
  `;
  document.body.appendChild(overlay);
  
  setTimeout(() => {
    overlay.remove();
  }, 3000);
};

return (
    <div style={{ width: '100%' }}>
    <div className="acceso-viewer-container">
      <div className="acceso-viewer-box">
        {/* Logo */}
        <div className="logo-container">
          <img 
            src="/img/logo.png" 
            alt="Ulalaaa" 
            className="logo"
          />
        </div>

        {/* Formulario */}
        <form onSubmit={handleInicioSesion} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          {/* Campo Usuario */}
          <div className="input-group">
            <input
              type="text"
              name="usuario"
              placeholder="Correo electronico o nombre de usuario"
              value={formData.usuario}
              onChange={handleChange}
              className="input-field"
            />
          </div>

          {/* Campo Clave */}
          <div className="input-group">
            <input
              type="password"
              name="clave"
              placeholder="Clave"
              value={formData.clave}
              onChange={handleChange}
              className="input-field"
            />
          </div>

          {/* Botones */}
<div style={{display:'flex', justifyContent:'center', margin:'10px 0'}}>
            <ReCAPTCHA
              ref={captchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(token) => setCaptchaToken(token)}
              onExpired={() => setCaptchaToken(null)}
              theme="dark"
              hl="es"
            />
          </div>

          <button type="submit" className="btn-inicio-sesion">
            Inicio Sesion
          </button>

<button
            type="button"
            onClick={() => setShowForgot(true)}
            style={{background:'none', border:'none', color:'rgba(255,255,255,0.7)', fontSize:'13px', cursor:'pointer', textDecoration:'underline', margin:'4px 0 8px 0', display:'block', width:'100%'}}
          >
            {'\u00BFOlvid\u00E9 mi clave?'}
          </button>

          <button
            type="button"
            onClick={handleRegistrarse}
            className="btn-registrarse"
          >
            Registrarse
          </button>

          {showForgot && (
            <ForgotPasswordViewer onClose={() => setShowForgot(false)} />
          )}
</form>
      </div>
    </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default AccesoViewer;
